<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
        
      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left:25px">{{ $t("fulfillment_detail") }}</h6>
                  <button
                    class="btn btn-light float-end"
                    type="button"
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapseExample" 
                    aria-expanded="false" 
                    aria-controls="collapseExample"
                  >
                    <i class="link-icon" data-feather="info"></i>
                    Audit Info
                  </button>

                  <div class="row mb-3 collapse" id="collapseExample" style="padding-left:20px">
                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0 ">Created By:</label>
                      <p class="text-muted">{{this.forms.addwho}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Created At:</label>
                      <p class="text-muted">{{this.forms.adddate}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                      <p class="text-muted">{{this.forms.editwho}}</p>
                    </div>

                    <div class="col-lg-3">
                      <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                      <p class="text-muted">{{this.forms.editdate}}</p>
                    </div>

                    
                    
                  </div>

                </div>

                <div class="card-body">

       
                  <form
                    class="forms-sample"
                    method="POST"
                  >

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t("fulfillment_code")
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="warehouseId"
                          :placeholder="$t('fulfillment_code')"
                          v-model="forms.warehouseId"
                          readonly
                        />
                        <div v-if="errors.warehouseId">
                          <div
                            v-for="error in errors.warehouseId"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    
                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('fulfillment_description')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="WarehouseDescr"
                          :placeholder="$t('fulfillment_description')"
                          v-model="forms.WarehouseDescr"
                          readonly
                        />
                        <div v-if="errors.WarehouseDescr">
                          <div
                            v-for="error in errors.WarehouseDescr"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('activeFlag_txt')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="text"
                        class="form-control"
                        id="activeFlag"
                        :placeholder="$t('activeFlag_txt')"
                        v-model="forms.activeFlag"
                        readonly
                      />
                      <div v-if="errors.activeFlag">
                        <div
                          v-for="error in errors.activeFlag"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

    


                  <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('salesGroup')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="salesGroup"
                          :placeholder="$t('salesGroup')"
                          v-model="forms.salesGroup"
                          readonly
                        />
                        <div v-if="errors.salesGroup">
                          <div
                            v-for="error in errors.salesGroup"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                  </div>

                                        
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('salesOffice')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="salesOffice"
                          :placeholder="$t('salesOffice')"
                          v-model="forms.salesOffice"
                          readonly
                        />
                        <div v-if="errors.salesOffice">
                          <div
                            v-for="error in errors.salesOffice"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
 
                                        
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('totalArea')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="totalArea"
                          :placeholder="$t('totalArea')"
                          v-model="forms.totalArea"
                          readonly
                        />
                        <div v-if="errors.totalArea">
                          <div
                            v-for="error in errors.totalArea"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                                        
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="totalPallet" class="col-form-label" style="padding-left: 25px">{{
                          $t('totalPallet')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="totalPallet"
                          :placeholder="$t('totalPallet')"
                          v-model="forms.totalPallet"
                          readonly
                        />
                        <div v-if="errors.totalPallet">
                          <div
                            v-for="error in errors.totalPallet"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      <a
                        v-if="permision_role.method_delete"
                        class="
                          btn btn-danger
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="deleteData()"
                      >
                        <i class="link-icon" data-feather="trash"></i>
                        {{ $t("deleteMess") }}
                      </a>

                      <a
                        v-if="permision_role.method_update"
                        class="
                          btn btn-primary
                          me-2
                          text-white
                          fw-bolder
                          btn-icon-text
                          float-end
                        "
                        @click="editData()"
                      >
                        <i class="link-icon" data-feather="edit"></i>
                        {{ $t("editMess") }}
                      </a>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "FulfillmentDetailCML",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      companyCode: "",
      companyName:"",
      forms: { idMaster_Warehouse: "", warehouseId: "" , WarehouseDescr:"", activeFlag:"", salesGroup:"", salesOffice:"", addwho:"", editwho:"", adddate:"", editdate:"", totalArea:0, totalPallet:0},

    };
  },
  watch: {},
  methods: {
    resetForm() {
      this.forms.company_group        = "";
      this.forms.idMaster_Warehouse = "";
      this.forms.warehouseId        = "";
      this.forms.WarehouseDescr     = "";
      this.forms.activeFlag         = "";
      this.forms.salesGroup         = "";
      this.forms.salesOffice        = "";
      this.forms.addwho             = "";
      this.forms.editwho            = "";
      this.forms.adddate            = "";
      this.forms.editdate           = "";
      this.forms.totalArea          = 0;
      this.forms.totalPallet        = 0;
    },


    cek_message(status, msg) {
      if (status == "200") {
        this.success(msg);
      }
    },

    editData() {
      var params = this.$route.params.id;
      window.location.href = "/billing-cml/master-warehouse/edit/" + params;
    },

    deleteData() {
      var id = this.$onBehind(this.$route.params.id);
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            status: status,
          };
          const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/warehouse/delete/" + id;
          this.$http
            .delete(baseURI, formData,{ timeout: 60000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/billing-cml/master-warehouse";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
                this.loading();
                this.isLoading = false;
                
       
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

            });
        }else{
          this.isLoading = false;
        }
      });
    },

    backForm() {
      window.location.href = "/billing-cml/master-warehouse";
    },

    loadData(id) {
      this.isLoading = true;

      const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/warehouse/detail/" + id;
      return this.$http.get(baseURI,{ timeout: 60000 }).then((response) => {
       this.isLoading = false;
        this.forms = response.data.datas;

      }).catch(error => {
          this.isLoading = false;
       
       
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }



        });
    },


      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'MasterWarehouseCmlController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_read){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },
 

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.cek_message(this.$route.query.status, this.$route.query.msg);
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.fetchIt();
  },
};
</script>
<style scoped>

</style>